import React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { useTheme, LightThemeColors } from '../../Themes';
import VFText from '../../VFText';

import styles from './TabItem.styles';

function TabItem({
  handleOnPress,
  tab,
  tabStyle,
  activeTab,
  allowFontScaling,
  activeTextStyle,
  inActiveTextStyle,
}) {
  const theme = useTheme() || LightThemeColors;
  return (
    <TouchableWithoutFeedback onPress={() => handleOnPress(tab.index)} accessible={false}>
      <View style={{ ...tabStyle }}>
        <VFText
          testKey={tab.accessibilityLabel}
          i18nKey={tab.tab_key}
          placeHolders={tab.placeHolders}
          style={
            tab.index === activeTab
              ? [styles.activeText, styles.activeTextColor(theme), activeTextStyle]
              : [styles.text, styles.textColor(theme), inActiveTextStyle]
          }
          allowFontScaling={allowFontScaling}
        />
      </View>
    </TouchableWithoutFeedback>
  );
}

TabItem.defaultProps = {
  tab: {
    index: 0,
    tab_key: '',
    accessibilityLabel: '',
  },
};

TabItem.propTypes = {
  tab: PropTypes.object,
  handleOnPress: PropTypes.func,
  tabStyle: ViewPropTypes.style,
  activeTab: PropTypes.number,
  allowFontScaling: PropTypes.bool,
  activeTextStyle: ViewPropTypes.style,
  inActiveTextStyle: ViewPropTypes.style,
};

export default TabItem;
